'use client';

import { Skeleton, Stack, Typography } from "@mui/material";

export default function ContactButtonsSkeleton() {
    return (
        <Stack spacing={4}>
            <Stack spacing={1}>
                <Typography variant="h3">Kontakt</Typography>
                <Skeleton variant="rectangular" width="100%" height={22} />
            </Stack>
            <Stack spacing={2}>
                <Skeleton variant="rectangular" width="100%" height={36} />
                <Skeleton variant="rectangular" width="100%" height={36} />
            </Stack>
        </Stack>
    );
}